import React from 'react';
import {useHistory} from 'react-router-dom/cjs/react-router-dom.min';

export default function ResponsiveBanner({banner, alt = 'banner'}) {
  const history = useHistory();

  if (!banner?.link) return null;

  const handleClick = () => {
    if (!banner.url) return;

    if (banner.url.startsWith('http')) {
      window.location.href = banner.url;
    } else {
      history.push(banner.url);
    }
  };

  return (
    <div style={{width: '100%', maxWidth: '100%'}}>
      <button
        type="button"
        onClick={handleClick}
        style={{
          display: 'flex',
          justifyContent:"center",
          width: '100%',
          padding: '0px 16px',
          marginBottom:"30px",
          border: 0,
          background: 'transparent',
          cursor: banner.url ? 'pointer' : 'default',
        }}
      >
        <img
          src={banner.link}
          alt={alt}
          style={{
            display: 'block',
            // width: '100%',
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </button>
    </div>
  );
}
